import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_DIGITS } from "../data/designOptions";

const FloatingWhatsApp = () => (
  <a
    href={`https://wa.me/${WHATSAPP_DIGITS}?text=${encodeURIComponent(
      "Hi Design Decor, I'd like to know more about your interiors."
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center bg-[#25D366] text-[#0A0A0A] shadow-[0_18px_50px_-12px_rgba(37,211,102,0.55)] transition-transform duration-300 hover:-translate-y-1 sm:bottom-8 sm:right-8"
  >
    <MessageCircle size={22} strokeWidth={1.8} />
  </a>
);

export default FloatingWhatsApp;
